var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWnEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83398 3.54167C2.44602 3.54167 2.12565 3.86203 2.12565 4.25V12.75C2.12565 13.138 2.44602 13.4583 2.83398 13.4583H14.1673C14.5553 13.4583 14.8757 13.138 14.8757 12.75V4.25C14.8757 3.86203 14.5553 3.54167 14.1673 3.54167H2.83398ZM0.708984 4.25C0.708984 3.07963 1.66362 2.125 2.83398 2.125H14.1673C15.3377 2.125 16.2923 3.07963 16.2923 4.25V12.75C16.2923 13.9204 15.3377 14.875 14.1673 14.875H2.83398C1.66362 14.875 0.708984 13.9204 0.708984 12.75V4.25Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.837089 3.84418C1.06143 3.5237 1.5031 3.44576 1.82358 3.6701L8.50071 8.34409L15.1778 3.6701C15.4983 3.44576 15.94 3.5237 16.1643 3.84418C16.3887 4.16467 16.3107 4.60634 15.9902 4.83068L8.90691 9.78901C8.66302 9.95973 8.3384 9.95973 8.09451 9.78901L1.01118 4.83068C0.690691 4.60634 0.61275 4.16467 0.837089 3.84418Z",
    fill: "#404040"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnEmail);
export default __webpack_public_path__ + "static/media/wn-email.9b98fb0314ad02e9e5f08da46c508269.svg";
export { ForwardRef as ReactComponent };